let createContainer = function createContainer() {
    const container = document.createElement('div');
    container.classList.add("cp-round");
    return container;
};

let createStyle = function createStyle() {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = `
      .cp-round:before, .cp-round:after {
          border-radius: 50%;
          content: " ";
          width: 90px;
          height: 90px;
          display: inline-block;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
      }

      .cp-round:before {
          border: solid 2px #bababa;
      }

      .cp-round:after {
          border: solid 2px transparent;
          border-top: solid 2px #202F53;
          animation: cp-round-animate 1s ease-in-out infinite;
      }

      @keyframes cp-round-animate {
          0% {
              transform: rotate(0);
          }
          100% {
              transform: rotate(360deg);
          }
      }
    `
    return styleElement;
};

class Spinner extends HTMLElement {
    constructor() {
        super();
        // if (this.parentNode) {
        //     this.parentNode.style.display = "none";
        // }
        //this.setAttribute("style",`padding:20px; margin: 0 auto; width: fit-content; pointer-events: none; display: none;`)
    }

    connectedCallback() {
        // if (this.parentNode) {
        //     this.parentNode.style.display = "none";
        // }
        this.setAttribute("style",`padding:20px; margin: 0 auto; width: fit-content; pointer-events: none; display: none;`)

       // this.style.display = "none";

        this.render();
        //this.style.padding = "20px";
        //this.style.margin = "0 auto";
        //this.style.width = "fit-content";
        //this.style["pointer-events"] = "none";
        //this.parentNode.style.visibility = "visible !important";
    }

    render() {
        this.appendChild(createStyle());
        this.appendChild(createContainer());
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "settings") {
            let settings = JSON.parse(newValue);
            // this.parentNode.style.display = settings.display;
            setTimeout(() => {
                this.setAttribute("style",`padding:20px; margin: 0 auto; width: fit-content; pointer-events: none; display: ${settings.display}`)
            }, 30);
            //this.style.display = settings.display;
        }
    }
    static get observedAttributes() {
        return ['settings'];
    }
}

customElements.define('spinner-element', Spinner);